import { ethers } from 'ethers';
const DEBUG_WALLET = typeof localStorage !== 'undefined'
    ? localStorage.getItem('impersonate')
    : null;
export const IS_IMPERSONATING = !!DEBUG_WALLET;
export function maybeDebugAccount(address) {
    var _a;
    // to enable debug mode, actual user wallet must be also connected
    if (DEBUG_WALLET && address) {
        return DEBUG_WALLET.toLowerCase();
    }
    return (_a = address === null || address === void 0 ? void 0 : address.toLowerCase()) !== null && _a !== void 0 ? _a : '';
}
export function impersonateAccount(address) {
    if (!address || !ethers.utils.isAddress(address.toLowerCase())) {
        throw new Error("It's not a valid Ethereum address.");
    }
    const lowercasedAddress = address.toLowerCase();
    if (window.confirm(`You are about to impersonate the account: ${lowercasedAddress}
This will set the address in localStorage and reload the page.
To stop impersonation, run stopImpersonatingAccount() in the console.

Do you want to proceed?`)) {
        if (typeof localStorage !== 'undefined') {
            localStorage.setItem('impersonate', lowercasedAddress);
            window.location.reload();
        }
    }
}
export function stopImpersonatingAccount() {
    if (typeof localStorage !== 'undefined') {
        localStorage.removeItem('impersonate');
        window.location.reload();
    }
}
(() => {
    if (typeof window !== 'undefined') {
        window.impersonateAccount = impersonateAccount;
        window.stopImpersonatingAccount = stopImpersonatingAccount;
    }
    if (IS_IMPERSONATING) {
        console.log('%cYou are in DEBUG MODE. All RPC requests will be called from the impersonated account. However transactions still will be signed with your connected wallet.\nTo stop impersonation, run stopImpersonatingAccount().', 'background: red; color: white; font-size: 16px; padding: 4px;');
    }
})();
